import { gql } from "@apollo/client";

export const STORAGE_RENTAL_FEES_QUERY = gql`
  query (
    $operatorId: Int!
    $transactionDateStart: String!
    $transactionDateEnd: String!
    $transactionStatus: String
    $doorSizeId: [Int]
    $lockerIds: [Int]
    $mobileNumber: String
  ) {
    storageRentalFees(
      operatorId: $operatorId
      transactionDateStart: $transactionDateStart
      transactionDateEnd: $transactionDateEnd
      transactionStatus: $transactionStatus
      doorSizeId: $doorSizeId
      lockerIds: $lockerIds
      mobileNumber: $mobileNumber
    ) {
      packageId
      packageDate
      packageStateNo
      transactionId
      packagePrice
      doorSizeId
      lockerId
      lockerName
      hours
      paymentDate
      paymentId
      paymentCurrency
      __typename
      recipientId
      senderId
      recipientMobile
      senderMobile

      duplicate
      duplicateCount
      #     -------------------------
      status
      #     excess fee == overstay fee
      # excessFee
      #     transaction fee = initial storage fee
      transactionFee
      #     total of excess and transaction
      paymentAmount
    }
  }
`;

export const SUMMARY_STORAGE_RENTALS_QUERY = gql`
  query (
    $operatorId: Int!
    $transactionDateStart: String!
    $transactionDateEnd: String!
    $lockerIds: [Int]
  ) {
    lockerSummary(
      operatorId: $operatorId
      transactionDateStart: $transactionDateStart
      transactionDateEnd: $transactionDateEnd
      lockerIds: $lockerIds
    ) {
      lockerId
      lockerName
      paymentCurrency
      earliestPackage
      latestPackage
      packages
      doorSizes
      totalHours
      totalFees
      totalPayments
      percentPerLockerPackages
      percentPerLockerPayments
      __typename
    }
  }
`;

export const AGGREGATE_STORAGE_FEES = gql`
  query (
    $operatorId: Int!
    $transactionDateStart: String!
    $transactionDateEnd: String!
    $transactionStatus: String
    $doorSizeId: [Int]
    $lockerIds: [Int]
    $mobileNumber: String
    $paymentCurrency: String
  ) {
    aggregateStorageRentalFees(
      operatorId: $operatorId
      transactionDateStart: $transactionDateStart
      transactionDateEnd: $transactionDateEnd
      transactionStatus: $transactionStatus
      doorSizeId: $doorSizeId
      lockerIds: $lockerIds
      mobileNumber: $mobileNumber
      paymentCurrency: $paymentCurrency
    ) {
      lockerId
      lockerName
      paymentCurrency
      paymentAmount
      totalTransactions
      doorSizeId
      status
      packageStateNo
      duplicate
      duplicateCount
      __typename
    }
  }
`;
